// extracted by mini-css-extract-plugin
module.exports = {"scrollbars":"styles_scrollbars__xBjfH","container":"styles_container__ijGNs","slideInSearchBar":"styles_slideInSearchBar__i_P5W"};